<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />

</svelte:head>

<script>

    import { logout } from "./api.svelte";
    import { sessionId } from "../utils/store";
    import { getContext } from "svelte";

    import {
        getLocalPropertyId,
        getLocalPropertiesInfo,
        sessionCleanup
    } from "../utils/session";

    import {
        errorReasons,
        userSupportCreate
    } from "./api.svelte";

    import { Dropdown } from "carbon-components-svelte";


    const router = getContext('router');

    export let tripadviser = true;
    export let active;

    const HIDDEN_NAV_ROUTES = ['login', 'register', 'reset', 'plans',
        'payment', 'locations', 'integrations', 'collecting'];

    let currentPopout = 'none';

    let supportFormLoading = false;
    let supportFormError = false;

    let supportForm = {
        'category': 'account',
        'propertyid': getLocalPropertyId(),
        'subject': '',
        'message': ''
    };

    $: isActive = (str) => active === str ? 'active' : '';
    $: isPopout = (str) => currentPopout === str ? 'active': '';

    $: getSupportProperties = () => {

        let supportProperties = [];

        for (const [propertyId, property] of Object.entries(getLocalPropertiesInfo())) {

            supportProperties.push({
                id: propertyId,
                text: property['name']
            });

        }

        return supportProperties;

    };


    const isChildOf = (parentClass, child) => {

        if (child && child.parentElement) {

            if (child.parentElement.tagName === 'nav') {

                return false;
            }

            if (child.parentElement.className.includes(parentClass)) {

                return true;
            }

            return isChildOf(child.parentElement);

        }

        return false;

    };

    let checkResetPopout = (e) => {

        if (!e.target) return;

        if (currentPopout === 'none') return;

        let tagName = e.target.tagName.toLowerCase();

        if (tagName === 'a' || tagName === 'nav'
            || e.target.parentElement.className.includes('nav-item')
            || (e.target.parentElement.parentElement
                && e.target.parentElement.parentElement.className.includes('nav-item'))) {

            currentPopout = 'none';
        }

    };

    let togglePopout = (popoutId, e = false) => {

        if (e && e.target) {

            if (e.target.className.includes('nav-popout')
                || isChildOf('nav-popout', e.target)) {

                return;
            }

        }

        if (currentPopout === popoutId) {

            currentPopout = 'none';
            return;

        }

        currentPopout = popoutId;

    };

    let handleSupportRequest = () => {

        if (supportFormLoading) return;

        if (supportForm['subject'] === '' || supportForm['message'] === '') {

            supportFormError = (supportForm['subject'] === '') ? 'subject' : 'message';

            setTimeout(() => {

                supportFormError = false;

            }, 2000);

            return;

        }

        supportFormLoading = true;

        userSupportCreate(supportForm).then((supportResult) => {

            supportFormLoading = false;

            if (supportResult['status'] !== 'success') {

                console.log(supportResult);
            }

            supportForm = {
                'category': 'account',
                'propertyid': getLocalPropertyId(),
                'subject': '',
                'message': ''
            };

        });

    };

    let logoutHandler = () => {

        logout().then((_) => {

            sessionId.set('');
            sessionCleanup();
            router.route('/login');

        });

    };

</script>


{#if !HIDDEN_NAV_ROUTES.includes(active)}

<nav on:click={(e) => checkResetPopout(e)}>

    <img id="logo" src="/keyosh-logo-beta.svg" alt="">

    <ul id="primary" class="nav">

        <li id="nav-home"  class="nav-item { isActive('dashboard') }">

            <a href="/">

                <img class="nav-icon" src="/images/icons/nav/home.svg" alt="">

            </a>

            <div class="nav-title">Dashboard</div>

        </li>

        <li id="nav-reviews" class="nav-item { isActive('reviews') }">

            <a href="/reviews">

                <img class="nav-icon" src="/images/icons/nav/reviews.svg" alt="">

            </a>

            <div class="nav-title">Bewertungen</div>

        </li>

        <li id="nav-keywords" class="nav-item { isActive('keywords') }">

            <a href="/keywords">

                <img class="nav-icon" src="/images/icons/nav/keywords.svg" alt="">

            </a>

            <div class="nav-title">Keywords</div>

        </li>

        {#if tripadviser}

            <li id="nav-guests" class="nav-item { isActive('guests') }">

                <a href="/guests">

                    <img class="nav-icon" src="/images/icons/nav/guests.svg" alt="">

                </a>

                <div class="nav-title">Gäste</div>

            </li>

        {/if}

        <li id="nav-table" class="nav-item { isActive('table') }">

            <a href="/table">

                <img class="nav-icon" src="/images/icons/nav/table.svg" alt="">

            </a>

            <div class="nav-title">Liste</div>

        </li>

    </ul>

    <ul id="secondary" class="nav">

        <li
                id="nav-notifications"
                class="popout-anchor {isPopout('notifications')}">

            <div
                    class="nav-element"
                    on:click={(e) => togglePopout('notifications', e)}>

                <img src="/images/icons/nav/notifications.svg" alt="">

            </div>

            <div class="nav-title">Nachrichten</div>

            <div id="popout-messages" class="nav-popout { isPopout('notifications') }">

                <div class="popout-title">Nachrichten</div>

                <div class="popout-container">

                    Keine neue Nachrichten.

                </div>

            </div>

        </li>

        <li
                id="nav-support"
                class="popout-anchor {isPopout('support')}">

            <div
                    class="nav-element"
                    on:click={(e) => togglePopout('support', e)}>

                <img src="/images/icons/nav/support.svg" alt="">

            </div>

            <div class="nav-title">Support</div>

            <div id="popout-support" class="nav-popout { isPopout('support') }">

                <div class="popout-title">Supportanfrage</div>

                <div class="popout-container forms">

                    <div class="section-title">Kategorie</div>

                    <Dropdown
                            bind:selectedId={supportForm['category']}
                            class="dropdown-select"
                            items={[
                            {id: 'account', text: 'Mein Account'},
                            {id: 'properties', text: 'Meine Standorte'},
                            {id: 'bug', text: 'Fehler gefunden'}
                        ]} />

                    {#if supportForm['category'] === 'properties'}

                        <div class="section-title">Standort</div>

                        <Dropdown
                                bind:selectedId={supportForm['propertyid']}
                                class="dropdown-select"
                                items={[
                                ...getSupportProperties()
                            ]} />

                    {/if}

                    <div class="section-title">Betreff</div>

                    <input
                            bind:value={supportForm['subject']}
                            class="{(supportFormError === 'subject') ? 'error-field' : ''}"
                            type="text"
                            placeholder="Betreff" />

                    <div class="section-title">Nachricht</div>

                    <textarea
                            bind:value={supportForm['message']}
                            class="{(supportFormError === 'message') ? 'error-field' : ''}"
                            rows="6"></textarea>

                    <button
                            on:click={() => handleSupportRequest()}
                            class={(supportFormLoading) ? 'loading btn' : 'btn'}>

                        <span>Absenden</span>
                        <img class="loader" src="/images/button-loader.svg" />

                    </button>

                </div>

            </div>

        </li>

        <li id="nav-settings" class="nav-item { isActive('settings') }">

            <a href="/settings/locations">

                <img src="/images/icons/nav/settings.svg" alt="">

            </a>

            <div class="nav-title">Einstellungen</div>

        </li>

        <li on:click={() => logoutHandler()} class="{ isActive('logout') }">

            <div class="nav-element">

                <img src="/images/icons/nav/logout.svg" alt="">

            </div>

            <div class="nav-title">Abmelden</div>

        </li>

    </ul>

</nav>

{/if}


<style>

    nav {
        position: fixed;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 9.26vh;
        height: 100vh;
        background-color: white;
        z-index: 9;
    }

    nav #logo {
        display: flex;
        align-self: center;
        width: 6.67vh;
        height: auto;
        margin-top: 2.68vh;
    }

    nav ul {
        display: flex;
        flex-direction: column;
        width: inherit;
        padding: 0;
        list-style-type: none;
    }

    nav ul#primary {
        margin-top: 7.11vh;
    }

    nav ul.nav li {
        position: relative;
        display: flex;
        width: inherit;
    }

    .nav li .nav-element,
    .nav li a {
        display: flex;
        width: inherit;
        padding: 2.6vh 0;
        justify-content: center;
    }

    #secondary.nav li .nav-element,
    #secondary.nav li a {
        padding: 1.5vh 0;
    }

    .nav li img:not(.loader) {
        display: flex;
        height: 2.67vh;
        filter: invert(86%) sepia(18%) saturate(288%) hue-rotate(208deg) brightness(82%) contrast(94%);
        transition: all 0.3s ease;
    }

    .nav li#nav-guests img {
        height: 2.4vh;
    }

    .nav li#nav-table img {
        height: 2.3vh;
    }

    #secondary.nav li {
        cursor: pointer;
    }

    #secondary.nav li img:not(.loader) {
        height: 2.5vh;
    }

    .nav li#nav-guests .nav-element img {
        height: 2.31vh;
    }

    .nav li#nav-table .nav-element img {
        width: 3.2vh;
        height: auto;
    }

    nav ul li {
        position: relative;
    }

    nav ul li .nav-title {
        visibility: hidden;
        opacity: 0;
        transition: all 0.3s ease;
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        left: calc(100% + 1.78vh);
        padding: 1.42vh 1.78vh;
        font-family: 'Raleway', sans-serif;
        font-weight: 500;
        font-size: 1.7vh;
        text-align: center;
        background-color: #FFFFFF;
        color: black;
        /*border-radius: 0.78vw;*/
        border-radius: 1.39vh;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.05);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.05);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.05);
        user-select: none;
        z-index: 9;
    }

    nav ul li:hover:not(.popout-anchor.active) .nav-title {
        visibility: visible;
        opacity: 1;
    }

    nav .nav-popout {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        visibility: hidden;
        opacity: 0;
        transition: all 0.3s ease;
        position: absolute;
        left: calc(100%  + 1.78vh);
        bottom: 0;
        height: auto;
        min-height: 6vh;
        padding: 0 1.78vh 1.42vh 1.78vh;
        font-family: 'Raleway', sans-serif;
        font-weight: 500;
        font-size: 1.3vh;
        text-align: center;
        background-color: #FFFFFF;
        color: black;
        cursor: auto;
        border-radius: 1.39vh;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.05);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.05);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.05);
    }

    nav .nav-popout.active {
        visibility: visible;
        opacity: 1;
    }

    .nav-popout .popout-container {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .nav-popout .section-title {
        margin-top: 1vh;
        margin-bottom: 0.5vh;
    }

    .nav-popout .section-title:first-child {
        margin-top: 0;
    }

    :global(.dropdown-select button) {
        font-size: 1.2vh;
    }

    :global(.dropdown-select button),
    :global(.bx--list-box__menu),
    input, textarea {
        width: 20vh;
        padding: 1vh;
        border: 0;
        outline: 0;
        background-color: #FFFFFF;
        border-radius: 0.78vh;
        -webkit-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.1);
        -moz-box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.1);
        box-shadow: 0px 5px 20px 0px rgba(73, 119, 172, 0.1);
    }

    input, textarea {
        width: 28vh;
        font-family: 'Raleway', sans-serif;
        font-weight: 400;
        font-size: 1.1vh;
        resize: none;
    }

    .forms input.error-field,
    .forms textarea.error-field {
        border: 1px solid #E83A91;
    }

    .popout-container button.btn {
        padding: 1vh;
        background-color: #22CDE8;
        width: 30vh;
        margin-top: 1vh;
        font-family: 'Raleway', sans-serif;
        font-weight: 500;
        font-size: 1.4vh;
        color: #FFFFFF;
        text-align: center;
        border-radius: 0.78vh;
        outline: 0;
        cursor: pointer;
    }

    #popout-messages {
        width: 20vh;
    }

    #popout-support {
        width: 30vh;
    }

    #popout-support .popout-container {
        align-items: flex-start;
        justify-content: center;
    }

    .popout-title {
        display: flex;
        height: 3vh;
        padding: 1.42vh;
        font-size: 1.5vh;
        color: #383874;
    }

    .nav > li:hover > .nav-element > img:not(.loader),
    .nav > li.active > .nav-element > img:not(.loader),
    .nav > li:hover > a > img:not(.loader),
    .nav > li.active > a > img:not(.loader) {
        filter: invert(78%) sepia(47%) saturate(4912%) hue-rotate(151deg) brightness(108%) contrast(82%);
    }

    .nav > li.active {
        background-image: url("/images/icons/nav/border.svg");
        background-position: left center;
        background-repeat: no-repeat;
    }


</style>